module.exports = __webpack_public_path__ + "static/img/step_1-button-selected.2788a122.png";